// @flow

export class ThreeDSecureError extends Error {
  code: string;

  constructor(message: string, code: string = 'THREEDSECURE') {
    super(message);
    this.code = code;
  }
}
